import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import './performanceAi.scss';
import { getModuleFromPath } from './performanceAiData.js';
import PerformanceAIHub from './Hub/index.jsx';
import OptimizationModel from './OptimizationModel/index.jsx';
import EnterprizeOptimization from './EnterpriseOptimization/index.jsx';
import Demand from './Demand/index.jsx';
import Sales from './Sales/index.jsx';
import Inventory from './Inventory/index.jsx';
import Logistics from './Logistics/index.jsx';
import Receivables from './Receivables/index.jsx';

export class PerformanceAIComponent extends React.Component {
    renderModule() {
        const module = getModuleFromPath(this.props.location.pathname);

        switch (module) {
            case 'enterprise-optimization':
                return <EnterprizeOptimization />;
            case 'optimization':
                return <OptimizationModel />;
            case 'demand':
                return <Demand />;
            case 'sales':
                return <Sales />;
            case 'inventory':
                return <Inventory />;
            case 'logistics':
                return <Logistics />;
            case 'receivables':
                return <Receivables />;
            case 'hub':
            default:
                return <PerformanceAIHub />;
        }
    }

    render() {
        return (
            <div className="performance-ai-page page-content">
                {this.renderModule()}
            </div>
        );
    }
}

export default withRouter(connect(
    (state) => ({
        authReducer: state.authReducer,
    })
)(PerformanceAIComponent));
